import { tokenPrefix } from '@hivewatch/dark'

type ColorScheme = 'dark' | 'light'

export const darkFloorsPanelStyles = (colorScheme: ColorScheme) => {
  const prefix = tokenPrefix(colorScheme)
  return {
    headerTitle: {
      color: `${prefix}text.primary`,
      textStyle: 'heading',
    },
    headerDescription: {
      color: `${prefix}text.secondary`,
      textStyle: 'caption',
    },
    toggleRow: {
      alignItems: 'center',
      display: 'flex',
      gap: '8px',
    },
    toggleLabel: {
      color: `${prefix}text.secondary`,
      fontFamily: "'Soehne', sans-serif",
      fontSize: '12px',
      fontWeight: '400',
      lineHeight: '16px',
    },
    filters: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '8px',
    },
    list: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '8px',
      pt: '8px',
    },
  }
}
